/**
 * Cold-start loading skeleton. Structure and class names must match index.html
 * so there’s no flash when React replaces the static shell (header + pink ticker + main placeholders).
 */
export const AppLoadingSkeleton = () => (
  <div className="app-loading-skeleton" aria-hidden="true">
    <header className="app-skeleton-header">
      <div className="app-skeleton-logo app-skeleton-shimmer" />
      <div className="app-skeleton-nav">
        <span className="app-skeleton-nav-pill app-skeleton-shimmer" />
        <span className="app-skeleton-nav-pill app-skeleton-shimmer" />
        <span className="app-skeleton-nav-pill app-skeleton-shimmer" />
      </div>
    </header>
    <div className="app-skeleton-ticker" aria-hidden="true" />
    <div className="app-skeleton-main">
      <div className="app-skeleton-title app-skeleton-shimmer" />
      <div className="app-skeleton-cards">
        <div className="app-skeleton-card app-skeleton-shimmer" />
        <div className="app-skeleton-card app-skeleton-shimmer" />
        <div className="app-skeleton-card app-skeleton-shimmer" />
        <div className="app-skeleton-card app-skeleton-shimmer" />
      </div>
    </div>
  </div>
);
